module.exports = __webpack_public_path__ + "img/fencing.35bbd680.svg";